import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Dialog, IconButton } from '@ori-ui/components';
import { Share as ShareIcon } from '@ori-ui/icons';
import { useCallback, useState } from 'react';
import { useTranslations } from "./hooks/useTranslations";
import { DialogRoot } from "./styles";
import { CopyLinkInputButton } from "../CopyLinkInputWithButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ShareAndCopyDialog = function ShareAndCopyDialog(props) {
  var _useTranslations = useTranslations(),
    copy = _useTranslations.copy,
    linkCopied = _useTranslations.linkCopied,
    modalTitle = _useTranslations.modalTitle;
  var copyUrl = props.copyUrl,
    _props$color = props.color,
    color = _props$color === void 0 ? 'default' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'large' : _props$size,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'contained' : _props$variant,
    _props$openDialog = props.openDialog,
    openDialog = _props$openDialog === void 0 ? false : _props$openDialog;
  var _useState = useState(openDialog),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var handleDialogToggle = useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      size: size,
      variant: variant,
      color: color,
      onClick: handleDialogToggle,
      children: /*#__PURE__*/_jsx(ShareIcon, {})
    }), /*#__PURE__*/_jsx(DialogRoot, {
      children: /*#__PURE__*/_jsx(Dialog, {
        header: modalTitle,
        open: isOpen,
        onClose: handleDialogToggle,
        children: /*#__PURE__*/_jsx(CopyLinkInputButton, {
          link: copyUrl,
          buttonText: copy,
          copiedText: linkCopied
        })
      })
    })]
  });
};
//# sourceMappingURL=ShareAndCopyDialog.js.map